import { spouseIds } from "@/lib/spouses";
export function lineageOptions(persons, form, memberId) {
  const currentId = memberId || "__new_member__";
  const original = persons.find((p) => p.id === memberId) || {};
  const removedParents = new Set([original.father_id, original.mother_id].filter((id) => id && ![form.father_id, form.mother_id].includes(id)));
  const removedChildren = new Set((original.children_ids || []).filter((id) => !(form.children_ids || []).includes(id)));
  const parents = new Map();
  const children = new Map();
  const link = (parent, child) => {
    if (!parent || !child) return;
    if (!parents.has(child)) parents.set(child, new Set());
    if (!children.has(parent)) children.set(parent, new Set());
    parents.get(child).add(parent);
    children.get(parent).add(child);
  };
  // The draft is authoritative for links involving the member being edited.
  persons.filter((p) => p.id !== currentId).forEach((p) => {
    [p.father_id, p.mother_id].filter((id) => id !== currentId || !removedChildren.has(p.id)).forEach((id) => link(id, p.id));
    (p.children_ids || []).filter((id) => id !== currentId || !removedParents.has(p.id)).forEach((id) => link(p.id, id));
  });
  [form.father_id, form.mother_id].forEach((id) => link(id, currentId));
  (form.children_ids || []).forEach((id) => link(currentId, id));
  const walk = (graph) => {
    const seen = new Set([currentId]);
    const stack = [...(graph.get(currentId) || [])];
    while (stack.length) {
      const id = stack.pop();
      if (seen.has(id)) continue;
      seen.add(id);
      stack.push(...(graph.get(id) || []));
    }
    seen.delete(currentId);
    return seen;
  };
  const ancestors = walk(parents);
  const descendants = walk(children);
  const others = persons.filter((p) => p.id !== currentId);
  const opposite = form.gender === "Male" ? "Female" : form.gender === "Female" ? "Male" : null;
  return {
    fathers: others.filter((p) => p.gender === "Male" && !spouseIds(form).includes(p.id) && !descendants.has(p.id)),
    mothers: others.filter((p) => p.gender === "Female" && !spouseIds(form).includes(p.id) && !descendants.has(p.id)
      && (!ancestors.has(p.id) || p.id === form.mother_id)),
    spouses: others.filter((p) => (spouseIds(p).includes(currentId) || spouseIds(p).length < 4) && opposite && p.gender === opposite && !ancestors.has(p.id) && !descendants.has(p.id)),
    children: others.filter((p) => !spouseIds(form).includes(p.id) && !ancestors.has(p.id)),
  };
}
